import RentaToolsConstants from "@/helpers/RentaToolsConstants";
import {RequestRawData} from "@/models/RequestRawData";

export default class GetReturnedMassProductRequest {
    public depoCostPools: string[] = [];
    public from: Date | null | undefined;
    public to: Date | null | undefined;
    public date: Date | null | undefined;
    public returnInspectionStatus: string[] = [];
    public modified: boolean = false;
    public contractId : string | null = "";
    public customerName: string = "";
    public projectNumber: string = "";
    public completedAtFrom: Date | null | undefined;
    public completedAtTo: Date | null | undefined;
    public pageNumber : number = 0;
    public pageSize : number = 0;

    public nextPage() : void{
        this.pageNumber++;
    }

    public resetPage() : void{
        this.pageNumber = 0;
        this.pageSize = RentaToolsConstants.itemsPerReturnInspectionPage;
    }
    
    constructor() {
        this.pageSize = 50;
    }

    static create(newRequest: RequestRawData) : GetReturnedMassProductRequest {
        const request = new GetReturnedMassProductRequest();
        request.to = newRequest.to;
        request.from = newRequest.from;
        request.date = newRequest.date;
        request.depoCostPools = newRequest.depoCostPools;
        request.returnInspectionStatus = newRequest.returnInspectionStatus;
        request.modified = newRequest.modified;
        request.contractId = newRequest.contractId;
        request.customerName = newRequest.customerName;
        request.projectNumber = newRequest.projectNumber;
        request.completedAtFrom = newRequest.completedAtFrom;
        request.completedAtTo = newRequest.completedAtTo;
        request.pageNumber = newRequest.pageNumber;
        request.pageSize = newRequest.pageSize;
        return request;
    }
    
    public isEmpty() : boolean {
        return this.depoCostPools.length === 0 &&
            this.from === null &&
            this.to === null &&
            this.date === null &&
            this.returnInspectionStatus.length === 0 &&
            this.contractId === "" &&
            this.customerName === "" &&
            this.projectNumber === "" &&
            this.completedAtFrom === null &&
            this.completedAtTo === null;
    }
}